<template>
    <div >
       <div class="showForm item">
            <el-tag>当前选择授权的表单</el-tag>：<template v-if="state!==1">【{{searchParams.modelName}}】</template>
            <el-tag type="success">授权的操作权限</el-tag>：【{{ this.modelAuthListView }}】
            <el-button  type="warning" size="mini" icon="el-icon-setting" title="设置修改操作权限"  circle @click="handleBatchModelAuth()"></el-button>
       </div>
       <div class="unauth-user-list">
        <!-- 左边应用列表 -->
          <div class="left-org" v-if="state==1">
              <div class="tit">
                应用列表
              </div>
              <el-input class="search-content"
                placeholder="请输入关键字"
                prefix-icon="el-icon-search"
                ref="tree"
                :filter-node-method="filterNode"
                v-model="filterText">
              </el-input>
              <div class="tree-body">
                  <el-tree class="filter-tree"
                      :data="treeData"
                      :default-expanded-keys="idExpandedArr"
                      :highlight-current="true"
                      :expand-on-click-node="false"
                      node-key="id"
                      show-checkbox
                      :filter-node-method="filterNode"
                      @node-click="getNode"
                      ref="tree"
                    >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>
                            <i :class="data.icon"></i>{{ data.label }}
                        </span>
                    </span>
                  </el-tree>
              </div>
            </div>
            <!-- 中间未授权人员列表 -->
            <div class="center-user">
                  <div class="tit">
                      未授权人员列表
                  </div>
                  <div class="searchUn" @keyup.enter="handleSearchUnAuthUser">
                      <el-input maxlength="100" v-model.trim="searchParams.unAssignedUserName" placeholder="员工姓名"  class="search-content">
                          <el-button slot="append" icon="el-icon-search" @click="handleSearchUnAuthUser"></el-button>
                      </el-input>
                  </div>
                  <div class="data-body">
                      <el-table ref="multipleTable" :data="unAssignedUserList" :row-key="getRowKeys"
                      :border="true" height="58vh" @selection-change="handleSelectionChange" :class="'unUserTable'">
                          <el-table-column type="selection" width="40" :reserve-selection="true" align="center"> </el-table-column>
                          <el-table-column width="150" prop="trueName" label="姓名" align="center"></el-table-column>
                          <el-table-column prop="empName" label="账号" align="center"></el-table-column>
                          <el-table-column prop="departmentName" label="部门" :filters="orgArray" :filter-method="filterOrg" align="center"></el-table-column>
                      </el-table>
                  </div>
            </div>
            <!-- 右边已选择人员列表 -->
            <div class="right-choose-user">
                <div class="tit">
                    选中的未授权人员
                </div>
                <div class="data-body">
                      <el-table :data="unAssignedChooseUserList"  height="63vh"  border :class="'unChooseUserTable'">
                          <el-table-column width="150" prop="trueName" label="姓名"></el-table-column>
                          <el-table-column prop="empName" label="账号"></el-table-column>
                          <el-table-column prop="departmentName" label="部门"></el-table-column>
                      </el-table>
                  </div>
            </div>
       </div>
        <el-dialog
            title="设置操作权限"
             append-to-body
            :visible.sync="isShowBatchModelAuthDialog">
            <SelectMultiple :key="loadTimer" ref="selectMultiple" :sourceOptions="sourceOptions" :selectViewFields="selectViewFields"  />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowBatchModelAuthDialog = false">取 消</el-button>
                <el-button type="primary" @click="chooseModelAuth">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Department from '@/components/Department';
    import {getOrgTreeList, getAppUnAssignList, getApplicationModelTreeMenu, getAllUserList} from '@/data-model';
    import SelectMultiple from '@/components/SelectMultiple/SelectMultipleAuth';
    export default{
        components: {
            SelectMultiple
        },
        data () {
            return {
                loadTimer: '',
                idExpandedArr: [],
                treeData: [],
                noAuthPage: {
                    currentPage: 1,
                    pageSize: 10,
                    totalPageNum: 1
                },
                unAssignedUserList: [],
                unAssignedChooseUserList: [],
                unAssignedChooseUserListContainer: [],
                filterText: '',
                getRowKeys (row) {
                    return row.userId;
                },
                sourceOptions: [
                    { id: 'ALL_SELECT', label: 'ALL' },
                    { id: '0', label: '查看' },
                    { id: '1', label: '新增' },
                    { id: '2', label: '修改' },
                    { id: '3', label: '删除' },
                    { id: '4', label: '导入' },
                    { id: '5', label: '导出' },
                    { id: '6', label: '同步流程数据' },
                    { id: '7', label: '进入应用配置' }
                ],
                // selectViewFields: [],
                selectViewFields: ['0', '1', '2', '3', '4', '5', '6', '7'],
                orgArray: [],
                isShowBatchModelAuthDialog: false,
                modelAuthListView: '' // 本次批量授权的操作权限
            };
        },
        comments: {
            Department
        },
        props: {
            searchParams: {
                type: Object
            },
            state: {
                type: Number,
                default: 0
            }
        },
        created () {
            if (this.state === 1) { // 多应用批量授权
                this.applicationList();
                this.getAllUserList();// 获取未授权人员列表
            } else {
                this.getUnUserList();// 获取未授权人员列表
                this._getTreeData();// 获取组织机构数据
            }
            this.modelAuthListView = this.getModelAuthListView(this.selectViewFields.join(','));
        },
        methods: {
            async _getTreeData () {
                let departmentTreeList = await getOrgTreeList();
                this.treeData = departmentTreeList;
            },
            async getAllUserList () {
                let param = {trueName: this.searchParams.unAssignedUserName};
                let res = await getAllUserList(param);
                this.unAssignedUserList = res;
                const m = new Map();
                this.orgArray = [];
                for (var i = 0; i < this.unAssignedUserList.length; i++) {
                    let obj = this.unAssignedUserList[i];
                    if (!m.has(obj.departmentId)) {
                        m.set(obj.departmentId, obj.departmentName);
                        let o = {text: obj.departmentName, value: obj.departmentName};
                        this.orgArray.push(o);
                    }
                }
            },
            async getUnUserList () {
                this.searchParams.mode = 2;
                this.unAssignedChooseUserListContainer = this.unAssignedChooseUserList;
                let formData = await getAppUnAssignList(Object.assign({}, {
                    currentPage: this.noAuthPage.currentPage,
                    pageSize: this.noAuthPage.pageSize
                }, this.searchParams));
                this.noAuthPage.currentPage = formData.currentPage;
                this.noAuthPage.pageSize = formData.pageSize;
                this.noAuthPage.totalPageNum = formData.totalPageNum;
                this.unAssignedUserList = formData.data;
                const m = new Map();
                this.orgArray = [];
                for (var i = 0; i < this.unAssignedUserList.length; i++) {
                    let obj = this.unAssignedUserList[i];
                    if (!m.has(obj.departmentId)) {
                        m.set(obj.departmentId, obj.departmentName);
                        let o = {text: obj.departmentName, value: obj.departmentName};
                        this.orgArray.push(o);
                    }
                }
            },
            async applicationList () {
                let param = {requireType: '0'};
                let modelTree = await getApplicationModelTreeMenu(param);
                this.treeData = modelTree;
                // 初始化默认展开到第二级
                if (this.treeData && this.treeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.treeData[0].id);
                }
            },
            handleSearchNoAuthListAssigned (currentPage) {
                this.noAuthPage.currentPage = currentPage;
                this.getUnUserList();
            },
            getNode (data) {
                // this.searchParams.mode = 2;
                // this.searchParams.orgId = data.id;
                // this.getUnUserList();
            },
            handleSearchUnAuthUser () {
                this.searchParams.mode = 2;
                // this.getUnUserList();
                this.getAllUserList();
            },
            buildParams () {
                return this.unAssignedChooseUserList;
            },
            buildTreeCheckd () {
                let nodes = this.$refs.tree.getCheckedNodes(true, false);
                return nodes;
            },
            filterNode (value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            handleSelectionChange (obj) {
                this.unAssignedChooseUserList = obj;
                if (this.unAssignedChooseUserList.length === 0) {
                    this.unAssignedChooseUserList = this.unAssignedChooseUserListContainer;
                    let _this = this;
                    if (_this.unAssignedChooseUserList.length > 0) {
                        // 回显已经选中的数据
                        _this.eachTableData();
                    }
                }
            },
            eachTableData () {
                this.unAssignedChooseUserList.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            },
            filterOrg (value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            handleBatchModelAuth () { // 设置详细权限
                this.isShowBatchModelAuthDialog = true;
                this.loadTimer = new Date().getTime();
                // if (isEmpty(row.modelUserAuthMap) || isEmpty(row.modelUserAuthMap[this.searchParams.formId]) || isEmpty(row.modelUserAuthMap[this.searchParams.formId].modelAuthList)) {
                //     this.selectViewFields = ['0', '1', '2', '3', '4', '5', '6', '7'];
                //     this.selectRow.user = row.userId;
                // } else {
                //     this.selectRow.userAuthObj = row.modelUserAuthMap[this.searchParams.formId];
                //     this.selectViewFields = row.modelUserAuthMap[this.searchParams.formId].modelAuthList.split(',');
                // }
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                }, 100);
            },
            async chooseModelAuth () {
                this.isShowBatchModelAuthDialog = false;
                let selectedFields = this.$refs.selectMultiple.getSelectFields();
                if (!selectedFields || selectedFields === '') {
                    this.$confirm(`您确定清空当前表单操作权限吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.selectViewFields = selectedFields.split(',');
                        this.modelAuthListView = this.getModelAuthListView(selectedFields);
                    }).catch(() => {
                    });
                } else {
                    this.selectViewFields = selectedFields.split(',');
                    this.modelAuthListView = this.getModelAuthListView(selectedFields);
                }
                //     this.modelUserAuth.modelId = this.searchParams.modelId;
                //     this.modelUserAuth.formId = this.searchParams.formId;
                //     this.modelUserAuth.users = this.selectRow.user;
                //     this.modelUserAuth.modelAuthList = selectedFields;
                //     await saveApplicationModelUserAuth(this.modelUserAuth);
                // } else {
                //     this.selectRow.userAuthObj.modelAuthList = selectedFields;
                //     await saveApplicationModelUserAuth(this.selectRow.userAuthObj);
                // }
                // this.assignedUserList.forEach(row => {
                //     if (row.userId === this.selectRow.userId) {
                //         row.modelAuthListView = this.getModelAuthListView(selectedFields);
                //     }
                // });
            },
            getModelAuthListView (selectedFields) {
                let modelAuthListView = '';
                modelAuthListView = selectedFields.replace('0', '0-查看');
                modelAuthListView = modelAuthListView.replace('1', '1-新增');
                modelAuthListView = modelAuthListView.replace('2', '2-修改');
                modelAuthListView = modelAuthListView.replace('3', '3-删除');
                modelAuthListView = modelAuthListView.replace('4', '4-导入');
                modelAuthListView = modelAuthListView.replace('5', '5-导出');
                modelAuthListView = modelAuthListView.replace('6', '6-同步流程数据');
                modelAuthListView = modelAuthListView.replace('7', '7-进入应用配置');
                return modelAuthListView;
            },
            getSelectAuthFields (selectedFields) {
                return this.selectViewFields && this.selectViewFields !== '' ? this.selectViewFields.join(',') : '';
            }
        },
        watch: {
            filterText (val) {
                this.$refs.tree.filter(val);
            }
        }
    };
</script>

<style lang="less" scoped>
.unauth-user-list{
    margin-top: 10px;
    height: 70vh;
    display: flex;
    .left-org{
       width: 20vw;
       height: 100%;
       overflow: auto;
       border: 1px solid #F0F0EE;
       .search-content{
           width: 92%;
           margin-left: 4%;
       }
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .tree-body{
           overflow: auto;
           width: 20vw;
       }
    }
    .center-user{
       width: 40vw;
       margin-left:2vw;
       height: 100%;
       overflow: auto;
       border: 1px solid #F0F0EE;
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .search-content{
           width: 92%;
           margin-left: 4%;
           margin-bottom: 1vh;
       }
       .unUserTable{
           width: 96%;
           margin-left: 2%;
           .gutter{
               width: 14px!important;
           }
           .el-table--border{
               border: none!important;
           }
           .el-table--group{
               border: none!important;
           }

       }

    }
    .right-choose-user{
       width: 40vw;
       margin-left: 2vw;
       border: 1px solid #F0F0EE;
       height: 100%;
       overflow: auto;
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .unChooseUserTable{
           width: 96%;
           margin-left: 2%;
           .gutter{
               width: 14px!important;
           }
           .el-table--border{
               border: none!important;
           }
           .el-table--group{
               border: none!important;
           }
       }
    }
}
.showForm{
        width: auto;
        // max-width: 240px;
        div{
            padding-left: 0px;
            font-size: 18px;
            color: red;
            font-weight: 700;
        }
    }
.dialog__body{
    padding-top: 10px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/FormModelAuth/UnAuthUserList.vue